<template>
<div class="contactpage">
    <div class="peopletitle">
        洽谈联系人
    </div>
    <div class="peopleInfo">
        <div class="people">
            <div class="people-box">
                <div class="people-left">
                    <img src="../assets/lingdai.png" alt="">
                </div>
                <div class="people-right">
                    <h1 style="margin-bottom: 10px;">李女士</h1>
                    <div class="tel">电话：13812922728</div>
                    <div class="tel">邮箱：rongfang.li@cesseon.com</div>
                </div>
            </div>
        </div>
        <div class="people">
            <div class="people-box">
                <div class="people-left">
                    <img src="../assets/lingdai.png" alt="">
                </div>
                 <div class="people-right">
                    <h1 style="margin-bottom: 10px;">邱女士</h1>
                    <div class="tel">电话：17621267255</div>
                    <div class="tel">邮箱：winni@cesseon.com</div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "Contact"
};
</script>

<style>
.tel{
    color: #7F7F7F;
    font-size: 17px;
}
.people-right {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
}

.people-left {
    width: 100px;
    height: 100px;
    border-radius: 80px;
    background: #4990E2;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 30px;
}
.people-left img{
    width: 80px;
    height: 80px;
}

.people-box {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    align-items: center;
}

.people {
    display: flex;
    flex: 1;
    height: 200px;
    padding: 40px;
    background: #fff;
    border-radius: 5px;
}

.people:last-child {
    margin-left: 10px;
}

.peopleInfo {
    padding: 0 40px;
    display: flex;
    flex-direction: row;
}

.peopletitle {
    width: calc(100% - 80px);
    text-align: center;
    font-size: 30px;
    padding: 60px 40px;
    color: white;
}

.contactpage {
    height: 500px;
    background: #0000;
    margin: 0 auto;
    width: 1190px;
    background: #42495F;
    
}
</style>
